import { fetch as apiFetch, postData } from "../../Component/function/FunctionApi";

const BASE_URL = "https://weviira-001-site1.jtempurl.com/api/";

/**
 * Get representatives
 */
export const getRepresentatives = async () => {
  try {
    const response = await apiFetch(
      "Represntative/get-Represntatives"
    );

    return response;
  } catch (error) {
    console.error("getRepresentatives error:", error);
    throw error;
  }
};

/**
 * Get representative daily data
 */
export const getRepresentativeDailyData = async (
  representativeId,
  date
) => {
  try {
    const params = new URLSearchParams({
      represntativeId: String(representativeId),
      dateDaily: `${date}T00:00:00`,
    });

    const response = await apiFetch(
      `Represntative/get-dailyDateOfRepresntative?${params.toString()}`
    );

    return response;
  } catch (error) {
    console.error("getRepresentativeDailyData error:", error);
    throw error;
  }
};

/**
 * Update shipping for all invoices
 */
export const updateDailyShipping = async ({
  representativeId,
  dailyDate,
  invoicesShipping,
}) => {
  try {
    const body = {
      representativeId: Number(representativeId),
      dailyDate,
      invoicesShipping: invoicesShipping.map((item) => ({
        invoiceId: Number(item.invoiceId),
        shipping: Number(item.shipping) || 0,
      })),
    };

    const response = await postData(
      "Represntative/update-daily-shipping",
      body,
      () => {}
    );

    return response;
  } catch (error) {
    console.error("updateDailyShipping error:", error);
    throw error;
  }
};

/**
 * Save daily settlement
 */
export const saveDailySettlement = async ({
  representativeId,
  dailyDate,
  cashAmount,
  instaPayAmount,
  vodafoneCashAmount,
  notes,
}) => {
  try {
    const body = {
      representativeId: Number(representativeId),
      dailyDate,
      cashAmount: Number(cashAmount) || 0,
      instaPayAmount: Number(instaPayAmount) || 0,
      vodafoneCashAmount: Number(vodafoneCashAmount) || 0,
      notes: notes || "",
    };

    const response = await postData(
      "Represntative/save-daily-settlement",
      body,
      () => {}
    );

    return response;
  } catch (error) {
    console.error("saveDailySettlement error:", error);
    throw error;
  }
};